var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 185,
    viewBox: "0 0 185 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 505"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 30",
    cx: 92.5,
    cy: 92.5,
    r: 92.5,
    fill: "#E7F4EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M80.8729 119.477L56.1155 94.8143C54.6282 93.3326 54.6282 90.9302 56.1155 89.4484L61.5019 84.0825C62.9893 82.6006 65.401 82.6006 66.8884 84.0825L83.5662 100.696L119.288 65.1113C120.775 63.6296 123.187 63.6296 124.675 65.1113L130.061 70.4772C131.548 71.9588 131.548 74.3612 130.061 75.843L86.2594 119.477C84.7719 120.959 82.3603 120.959 80.8729 119.477Z",
    fill: "#0D894F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/GreenTick.173805736f5fea6d8fc0591409d295b2.svg";
export { ForwardRef as ReactComponent };